<template>
    <div v-html="renderedHtml" class="markdown-body"></div>
</template>

<script>

import MarkdownIt from "markdown-it";
import DOMPurify from "dompurify";

const md = new MarkdownIt({
    html: false,
    linkify: true,
    typographer: true
});

export default {
    props: {
        text: {
            type: String,
            required: true
        }
    },
    computed: {
        renderedHtml() {
            if (!this.text) return "";
            const rawHtml = md.render(this.text);
            return DOMPurify.sanitize(rawHtml);
        }
    }
}
</script>

<style lang="scss" scoped>
.markdown-body {
  background-color: white;
  color: #212121;
  font-size: 0.95rem;
  line-height: 1.6;
  word-break: break-word;
}

.markdown-body p {
  margin-bottom: 0.75rem;
}

.markdown-body ul,
.markdown-body ol {
  padding-left: 1.2rem;
  margin-bottom: 0.75rem;
}

.markdown-body strong {
  font-weight: 600;
}

.markdown-body a {
  color: #1976d2;
  text-decoration: none;
}

.markdown-body a:hover {
  text-decoration: underline;
}
</style>